// extracted by mini-css-extract-plugin
module.exports = {"clip_and_preview_tab":"ClipsAndPreviewsTab_clip_and_preview_tab__MFBIm","clips_and_previews":"ClipsAndPreviewsTab_clips_and_previews__Au2z3"};